import React from 'react';
import { Link } from "react-router-dom";

import LoaderView from './loader';

const env = require("../../config.js").default;
const common = require('../common/common');

class LoginComplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.state.code = -1;
    this.state.error = null;
    this.state.error_description = null;
  }

  componentWillMount(){
    var code = common.getParam("code");
    var state = common.getParam("state");
    var error = common.getParam("error");
    var error_description = common.getParam("error_description");
    if(error_description !== null)
      error_description = error_description.replace(/\+/g, " ");

    if(code !== null && error === null){

      var next = null;
      if(state !== null){
        if(state !== common.get_sessionStorage("sw_oauth2_state")){
          this.setState({"error": "state_verify_error", "error_description": common.getTrad("Errore di verifica credenziali")});
          return false;
        }
        state = atob(state);
        var splittedState = state.split(common.nonceSeparator);
        if(splittedState && splittedState.length>0 && splittedState[1])
          next = splittedState[1];
      }

      var fetchParams = {
        method: "POST",
        headers: new Headers({
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept-Language': common.getLanguage(true),
          //'Authorization': 'Basic ' + btoa(env.BACKEND_LOGIN_CLIENT_ID + ":" + env.BACKEND_LOGIN_CLIENT_SECRET)
        }),
        body: 'grant_type=authorization_code&code=' + code + "&client_id=" + env.BACKEND_LOGIN_CLIENT_ID,
      };

      return fetch(env.LOGIN_BACKEND + "o/token/", fetchParams).then((response) => {
        if (!response.ok) {
          var error = Error(response.status);
          error.response = response.json()
          throw error
        }
        return response.json();
      }).then((result) => {
        common.set_localStorage("appState", result.access_token);

        if(next !== null)
          window.location.href = next;
        else
          window.location.href = env.FRONTEND;
        return result.access_token;
      }).catch((error) => {
        this.setState({"error": "get_token_error", "error_description": common.getTrad("Errore di verifica credenziali")});
        return false;
      })


    }

    this.setState({"code": code, "error": error, "error_description": error_description});
  }

  componentDidMount(){
    document.title = env.APP_NAME + " - Login";
  }

  render(props){
    if(this.state.code !== null && this.state.error === null)
      return (<LoaderView></LoaderView>)
    else
      return(
        <div className="content_testo tab-content">
          <div id="content-core">
            <div className="row" style={{alignItems: "center", height: "calc(100vh - var(--header-height) - var(--footer-height))"}}>
              <div className="col-xl-12 text-center content_error">
                <h1 className="animated fadeInUp delay-03s">
                  { this.state.error !== null ? common.getTrad("Errore di login") : common.getTrad("Login Completo")}
                </h1>
                {this.state.error_description ?
                  <h3 className="animated fadeInUp delay-06s">
                    {this.state.error_description}
                  </h3>
                :
                  <></>
                }
                { this.state.error !== null ?
                  <h3 className="animated fadeInUp delay-06s">
                    <Link to="/">{common.getTrad("Ritenta il login")}</Link>
                  </h3>
                :
                  <></>
                }
              </div>
            </div>
          </div>
        </div>
      )
  }
}


export default LoginComplete;
